"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerToJSON = exports.SignerFromJSONTyped = exports.SignerFromJSON = exports.instanceOfSigner = exports.SignerTypeEnum = exports.attributeTypeMapSigner = void 0;
var RecipientItems_1 = require("./RecipientItems");
var Attachment_1 = require("./Attachment");
var SignerAllOfRole_1 = require("./SignerAllOfRole");
exports.attributeTypeMapSigner = [
    {
        name: "type",
        type: "string",
    },
    {
        name: "email",
        type: "string",
    },
    {
        name: "name",
        type: "string",
    },
    {
        name: "attachments",
        type: "Array<Attachment>",
    },
    {
        name: "accessCode",
        type: "string",
    },
    {
        name: "smsAuthNumber",
        type: "string",
    },
    {
        name: "smsDeliveryMobileNumber",
        type: "string",
    },
    {
        name: "deliveryType",
        type: "string",
    },
    {
        name: "role",
        type: "SignerAllOfRole",
    },
    {
        name: "authType",
        type: "string",
    },
    {
        name: "order",
        type: "number",
    },
];
/**
 * @export
 */
exports.SignerTypeEnum = {
    Signer: "signer",
};
/**
 * Check if a given object implements the Signer interface.
 */
function instanceOfSigner(value) {
    if (!("type" in value) || value["type"] === undefined)
        return false;
    if (!("email" in value) || value["email"] === undefined)
        return false;
    if (!("name" in value) || value["name"] === undefined)
        return false;
    if (!("attachments" in value) || value["attachments"] === undefined)
        return false;
    if (!("accessCode" in value) || value["accessCode"] === undefined)
        return false;
    if (!("smsAuthNumber" in value) || value["smsAuthNumber"] === undefined)
        return false;
    if (!("smsDeliveryMobileNumber" in value) ||
        value["smsDeliveryMobileNumber"] === undefined)
        return false;
    if (!("deliveryType" in value) || value["deliveryType"] === undefined)
        return false;
    return true;
}
exports.instanceOfSigner = instanceOfSigner;
function SignerFromJSON(json) {
    return SignerFromJSONTyped(json, false);
}
exports.SignerFromJSON = SignerFromJSON;
function SignerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return __assign(__assign({}, (0, RecipientItems_1.RecipientItemsFromJSONTyped)(json, ignoreDiscriminator)), { type: json["type"], email: json["email"], name: json["name"], attachments: json["attachments"].map(Attachment_1.AttachmentFromJSON), accessCode: json["access_code"], smsAuthNumber: json["sms_auth_number"], smsDeliveryMobileNumber: json["sms_delivery_mobile_number"], deliveryType: json["delivery_type"], role: json["role"] == null ? undefined : (0, SignerAllOfRole_1.SignerAllOfRoleFromJSON)(json["role"]), authType: json["auth_type"] == null ? undefined : json["auth_type"], order: json["order"] == null ? undefined : json["order"] });
}
exports.SignerFromJSONTyped = SignerFromJSONTyped;
function SignerToJSON(value) {
    if (value == null) {
        return value;
    }
    return __assign(__assign({}, (0, RecipientItems_1.RecipientItemsToJSON)(value)), { type: value["type"], email: value["email"], name: value["name"], attachments: value["attachments"].map(Attachment_1.AttachmentToJSON), access_code: value["accessCode"], sms_auth_number: value["smsAuthNumber"], sms_delivery_mobile_number: value["smsDeliveryMobileNumber"], delivery_type: value["deliveryType"], role: (0, SignerAllOfRole_1.SignerAllOfRoleToJSON)(value["role"]), auth_type: value["authType"], order: value["order"] });
}
exports.SignerToJSON = SignerToJSON;
